import React, { useCallback } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Text from 'design-system/Text';
import { hitSlop } from 'design-system';
import IconTooltip from 'design-system/icons/IconTooltip';
import ToolTip from 'design-system/ToolTip';
import { InfoModal } from './InfoModal';
import { isWeb } from '../../../constants';
const StockFinancialCardsHeader = ({ title, infoModalTitle, infoModalDesc }) => {
    const showInfo = useCallback(() => {
        InfoModal.show(infoModalTitle, infoModalDesc);
    }, [infoModalDesc, infoModalTitle]);
    return (<View style={styles.container}>
      <Text Text-16 Secondary flex>
        {title}
      </Text>
      {isWeb ? (
        // On web the explanation shows on hover rather than in a modal
        <ToolTip title={infoModalTitle} subtitle={infoModalDesc}/>) : (<TouchableOpacity hitSlop={hitSlop} onPress={showInfo}>
          <IconTooltip />
        </TouchableOpacity>)}
    </View>);
};
export default StockFinancialCardsHeader;
const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
    },
});
